<template>
    <div class="container">
        <div class="vld-parent">
            <loading :active.sync="open_loader"
                     :can-cancel="false"
                     :is-full-page="true">

            </loading>
        </div>
        <div class="row" style="margin-top: 10%">

            <div class="col-md-3"></div>
            <div class="col-md-6">
                <div class="panel panel-default">
                    <div class="panel-heading">Promjena zaporke</div>

                    <div class="panel-body">
                        <div class="col-md-12" style="text-align: center">
                            <img src="@/img/app/izzyedu.png" style="align-items: center; max-width: 100%; margin-bottom: 50px">
                        </div>

                        <form class="form-horizontal">

                            <div :class="{'form-group': true}">

                                <label
                                        for="password"
                                        class="col-md-4 control-label"
                                >
                                    Lozinka
                                </label>

                                <div class="col-md-12">
                                    <input
                                            id="password"
                                            type="password"
                                            class="form-control"
                                            name="password"
                                            v-model="password"
                                            required
                                    >

                                    <span
                                            v-if="errors && errors.password"
                                            class="help-block"
                                    >
                                        <strong>
                                            {{errors.password[0] }}
                                        </strong>
                                    </span>

                                </div>
                            </div>

                            <div :class="{'form-group': true}">

                                <label
                                        for="password_confirm"
                                        class="col-md-4 control-label"
                                >
                                    Ponovi louinku
                                </label>

                                <div class="col-md-12">
                                    <input
                                            id="password_confirm"
                                            type="password"
                                            class="form-control"
                                            name="password_confirm"
                                            v-model="password_confirm"
                                            required
                                    >

                                    <span
                                            v-if="errors && errors.password_confirm"
                                            class="help-block"
                                    >
                                        <strong>
                                            {{errors.password_confirm[0] }}
                                        </strong>
                                    </span>

                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-md-8 col-md-offset-4">
                                    <button type="submit" class="btn btn-primary" @click.prevent="resetPassword">
                                        Potvrdi
                                    </button>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loading from 'vue-loading-overlay'
import toastr from "toastr";
export default {
    name: "ResetPassword",
    components:{ Loading },
    data: function() {
        return {
            password: null,
            password_confirm: null,
            errors: null,
            open_loader: false,
        }
    },
    methods:{
        resetPassword: function () {
            let vm = this;
            vm.open_loader = true;
            axios.post(process.env.VUE_APP_API_URL + "reset-password", {
                password_confirm: vm.password_confirm,
                password: vm.password,
                token: this.$route.params.token
            })
                .then(response => {
                    if( response.data.success ){
                        toastr.success('Lozinka je uspješno promijenjena, možete se prijaviti')
                        vm.$router.push('/login')
                    } else {
                        vm.errors = response.data.messages
                    }
                    vm.open_loader = false
                })
                .catch( function ( error ) {
                    if(error instanceof Error) {
                        console.log( 'Error: ' . error);
                    } else {
                        console.log( 'Unexpected response: ' . error);
                    }
                    vm.open_loader = false
                } )
        }
    }
}
</script>

<style scoped>

</style>